import { Box, Typography } from "@mui/material";
import Delete from "../../assets/Delete.svg";
import {
  CartItemContainer,
  CartItemImage,
  CartItemDetails,
  CartItemName,
  QuantityText,
  ActionsContainer,
  PriceText,
  QuantityContainer,
  QuantityButton,
  DeleteButton,
} from "./CartItem.styles";

interface CartItemProps {
  item: {
    id: number;
    name: string;
    image: string;
    quantity: number;
    unit: number;
    price: number;
  };
  onIncrement: (id: number) => void;
  onDecrement: (id: number) => void;
  onRemove: (id: number) => void;
  getFormattedQuantity: (value: number, quantity: number) => string;
}

const CartItem = ({
  item,
  onIncrement,
  onDecrement,
  onRemove,
  getFormattedQuantity,
}: CartItemProps) => {
  const totalPrice = item.price * item.quantity * item.unit;
  return (
    <CartItemContainer>
      <CartItemImage src={item.image} alt={item.name} />

      <CartItemDetails>
        <CartItemName>{item.name}</CartItemName>
        <Box display="flex" alignItems="center" flexWrap="wrap">
          <QuantityText variant="body2">Quantity:&nbsp;</QuantityText>
          <QuantityText variant="body2">
            {getFormattedQuantity(item.quantity, item.unit)}
          </QuantityText>
        </Box>
      </CartItemDetails>

      <ActionsContainer>
        <PriceText noWrap>₹ {totalPrice}</PriceText>
        <QuantityContainer>
          <QuantityButton onClick={() => onDecrement(item.id)}>
            -
          </QuantityButton>
          <Typography>{item.unit}</Typography>
          <QuantityButton onClick={() => onIncrement(item.id)}>
            +
          </QuantityButton>
        </QuantityContainer>
        <DeleteButton
          color="error"
          onClick={() => onRemove(item.id)}
          data-testid="delete-button"
          size="small"
        >
          <img src={Delete} alt="delete" />
        </DeleteButton>
      </ActionsContainer>
    </CartItemContainer>
  );
};

export default CartItem;
